import { getEmojiPlugin, getMentionsPlugin } from '@lyearn/lygo-blocks';
import { getSchema, Schema } from '@lyearn/lygo-core';
import UserTooltipProvider from '@/components/User/layouts/UserTooltipProvider';
import { messageEditorExtensions } from '@/lygo/MessageEditor';
import * as Mentions from '@/modules/corporate/modules/channel/views/ChannelDetails/components/MessageInput/plugins/Mentions/mention-entities';

import EmojiList from '../../../components/MessageInput/plugins/Emoji';
import MentionsList from '../../../components/MessageInput/plugins/Mentions';

const MENTIONS_FACTORY = {
  CONTENT: Mentions.ContentMention,
  USER: Mentions.UserMention,
  EVENT: Mentions.EventMention,
};

const initEditor = (disableMentions?: boolean) => {
  const { nodes, marks, plugins, nodePerformanceMap } = getSchema(messageEditorExtensions as any);
  const schema = new Schema({ marks, nodes });

  return {
    schema,
    nodePerformanceMap: nodePerformanceMap as any,
    plugins: [
      ...plugins,
      // add typeahead emoji search on colon ':'
      getEmojiPlugin({ ListComponent: EmojiList }),
      //TODO: remove this flag, make plugins "pluggalbe" for channels
      ...(!disableMentions
        ? [
            getMentionsPlugin({
              ListComponent: (props) => (
                <MentionsList MentionsFactory={MENTIONS_FACTORY} {...props} />
              ),
              UserTooltipProvider: UserTooltipProvider,
            }),
          ]
        : []),
    ],
  };
};

export default initEditor;
